import {
  Box,
  Skeleton,
  SkeletonGroup,
} from "@salestrak/ui";
import { ACCESS_ROW_HEIGHT, ACCESS_VISUAL_PX } from "./access-row";

// ─── Skeletons ───────────────────────────────────────────────────────
// Mirror the settled list: two header rows, the workspace row with its two
// controls and the group with its face stack. A team's roster IS knowable
// (its row carries the count) and mirrors exactly.

export function SkeletonRow({ height }: { height: number }) {
  return (
    <Box direction="row" align="center" gap="base" height={height}>
      <Skeleton width={ACCESS_VISUAL_PX} circle />
      <Box flex={1}>
        <Skeleton width={128} height={14} />
      </Box>
      <Skeleton width={88} height={28} />
    </Box>
  );
}

export function ShareListSkeleton({ hasLink = false }: { hasLink?: boolean }) {
  return (
    <SkeletonGroup>
      <Box gap="sm">
        {/* The link row leads when the wrapper has a link: a label and a
            reach line, and the squared button on the controls' edge. */}
        {hasLink ? (
          <Box direction="row" align="center" justify="between" height={ACCESS_ROW_HEIGHT + 4}>
            <Skeleton width={224} height={14} />
            <Skeleton width={96} height={28} />
          </Box>
        ) : null}
        <Box direction="row" align="center" justify="between" height={ACCESS_ROW_HEIGHT + 4}>
          <Skeleton width={200} height={14} />
          <Box direction="row" align="center" gap="sm">
            <Skeleton width={88} height={28} />
            <Skeleton width={28} height={16} />
          </Box>
        </Box>
        <Box direction="row" align="center" justify="between" height={ACCESS_ROW_HEIGHT + 4}>
          <Skeleton width={96} height={14} />
          <Skeleton width={56} height={16} />
        </Box>
      </Box>
    </SkeletonGroup>
  );
}
